import * as React from "react";

import ErrorIcon from "@mui/icons-material/Error";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { useUpdate } from "../../hooks/useUpdate";
import useDialog from "../useDialog";

import { ActionListItem } from "./listItems";

interface Props {
    hideIfNoUpdate?: boolean;
}

export default function AboutListItem({
    hideIfNoUpdate = true,
}: Props): React.JSX.Element | null {
    const { setDialogType } = useDialog();
    const { showAvailableUpdate, versionString } = useUpdate();

    if (hideIfNoUpdate && !showAvailableUpdate) {
        return null;
    }

    // Show update-specific UI when update is available
    if (showAvailableUpdate) {
        return (
            <ActionListItem
                action={() => setDialogType("UserUpdate")}
                priority
                icon={<ErrorIcon color="error" fontSize="small" />}
            >
                <Stack direction="row">
                    <Typography variant="h4" component="span">
                        Update available
                    </Typography>
                </Stack>
            </ActionListItem>
        );
    }

    // Show standard "About" link when no update available
    return (
        <ActionListItem action={() => setDialogType("About")} priority={false}>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                width="100%"
            >
                <Typography variant="h4" component="span">
                    About
                </Typography>
                {versionString && (
                    <Typography
                        variant="h4"
                        component="span"
                        color="text.secondary"
                    >
                        v{versionString}
                    </Typography>
                )}
            </Stack>
        </ActionListItem>
    );
}
